import React from "react";

/**
 * Estrellas de calificación reales.
 * - Solo muestra estrellas si hay al menos una calificación (rating_count > 0).
 * - En caso contrario muestra "Nuevo" (sin inventar un promedio falso).
 */
export default function RatingStars({ avg, count, className = "" }) {
    const ratingCount = Number(count) || 0;

    if (ratingCount <= 0) {
        return (
            <div className={`flex items-center mt-2 ${className}`}>
                <span className="text-slate-400 text-sm">Nuevo</span>
            </div>
        );
    }

    const ratingAvg = Number(avg) || 0;
    const fullStars = Math.round(ratingAvg);

    return (
        <div className={`flex items-center mt-2 ${className}`}>
            <span className="text-slate-400">Valoración:</span>
            <ul className="text-lg font-medium text-amber-400 list-none ms-2 space-x-1" role="img" aria-label={`${fullStars} de 5 estrellas`}>
                {[1, 2, 3, 4, 5].map((n) => (
                    <li className="inline" key={n}>
                        <i className={`mdi mdi-star${n <= fullStars ? "" : "-outline"} align-middle`} aria-hidden="true"></i>
                    </li>
                ))}
                <li className="inline text-black dark:text-white text-sm">
                    {ratingAvg.toFixed(1)}({ratingCount})
                </li>
            </ul>
        </div>
    );
}
